import { SortOption } from '@src/v3/interfaces/components/coreUI/filterDropdown/sortDropdown';
import SortUpDown from '@src/v3/assets/svg/sortUpDown';
import ChevronUp from '@src/v3/assets/svg/chevronUp';
import SortDown from '@src/v3/assets/svg/sortDown';

export const SORT_OPTIONS: SortOption[] = [
  {
    id: 'newest_to_oldest',
    label: 'Newest to Oldest',
    icon: SortUpDown,
  },
  {
    id: 'oldest_to_newest',
    label: 'Oldest to Newest',
    icon: SortUpDown,
  },
  {
    id: 'price_low_to_high',
    label: 'Lowest to Highest Price',
    icon: SortDown,
  },
  {
    id: 'price_high_to_low',
    label: 'Highest to Lowest Price',
    icon: ChevronUp,
  },
];
